import { render, staticRenderFns } from "./uploadOss.vue?vue&type=template&id=2669517d&scoped=true&"
import script from "./uploadOss.vue?vue&type=script&lang=js&"
export * from "./uploadOss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669517d",
  null
  
)

export default component.exports